import React from 'react';
import { useGoogleFormModal } from '../App';

const HeroSlide = ({
    backgroundImage,
    title,
    subtitle = "C2 Community",
    buttonText = "Join the Movement",
    buttonLink = "#manifesto",
    overlayOpacity = 0.5
}) => {
    const { openGoogleFormModal } = useGoogleFormModal();
    return (
        <div className="swiper-slide" style={{ height: '100vh', width: '100%', overflow: 'hidden', position: 'relative' }}>
            <div
                className="image-layer"
                style={{
                    backgroundImage: `url(${backgroundImage})`,
                    height: '100%',
                    width: '100%',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: 0
                }}
            ></div>
            <div
                className="image-layer-overlay"
                style={{
                    opacity: overlayOpacity,
                    pointerEvents: 'none',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 1
                }}
            ></div>
            <div className="main-slider-two__shape-1" style={{ pointerEvents: 'none', zIndex: 2 }}>
                <img src="assets/images/shapes/main-slider-two-shape-1.png" alt="" />
            </div>
            <div className="main-slider-two__shape-2" style={{ pointerEvents: 'none', zIndex: 2 }}>
                <img src="assets/images/shapes/main-slider-two-shape-2.png" alt="" />
            </div>
            <div className="main-slider-two__big-text-1" style={{ pointerEvents: 'none', zIndex: 2 }}>C2</div>
            <div className="main-slider-two__big-text-2" style={{ pointerEvents: 'none', zIndex: 2 }}>Community</div>
            <div className="container" style={{ position: 'relative', zIndex: 10, pointerEvents: 'auto' }}>
                <div className="row">
                    <div className="col-xl-12">
                        <div className="main-slider__content">
                            <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
                            <div className="main-slider-two__btn-box">
                                <button
                                    onClick={openGoogleFormModal}
                                    className="thm-btn main-slider-two__btn"
                                    style={{
                                        border: 'none',
                                        padding: '10px 20px',
                                        font: 'inherit',
                                        cursor: 'pointer',
                                        position: 'relative',
                                        zIndex: 20,
                                        pointerEvents: 'auto'
                                    }}
                                >
                                    {buttonText}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroSlide;
